import { makeId, normalizePanelThickness } from "../fixtures/defaults";

const MIN_REST_SIZE = 40;

export function emptyRestStockItem(defaultThickness = 18) {
  return {
    id: makeId(),
    label: "",
    length: "",
    width: "",
    thickness: normalizePanelThickness(defaultThickness),
    quantity: 1,
  };
}

export function normalizeRestStock(raw, defaultThickness = 18) {
  if (!Array.isArray(raw)) return [];

  const fallbackThickness = normalizePanelThickness(defaultThickness);

  return raw.map((item) => ({
    id: item?.id || makeId(),
    label: String(item?.label || ""),
    length: Math.max(Number(item?.length) || 0, 0),
    width: Math.max(Number(item?.width) || 0, 0),
    thickness: normalizePanelThickness(item?.thickness ?? fallbackThickness),
    quantity: Math.max(Math.floor(Number(item?.quantity) || 0), 0),
  }));
}

export function isValidRestStockItem(item) {
  return item.length >= MIN_REST_SIZE
    && item.width >= MIN_REST_SIZE
    && item.quantity > 0;
}

export function expandRestStockForPacking(restStock) {
  const sheets = [];

  restStock
    .filter(isValidRestStockItem)
    .forEach((item) => {
      for (let occurrence = 1; occurrence <= item.quantity; occurrence += 1) {
        sheets.push({
          restStockId: item.id,
          label: item.label || `Rest ${item.length} × ${item.width}`,
          length: item.length,
          width: item.width,
          thickness: item.thickness,
          occurrence,
        });
      }
    });

  return sheets.sort((a, b) => (b.length * b.width) - (a.length * a.width));
}

export function restStockForThickness(restStock, thickness) {
  return expandRestStockForPacking(restStock).filter((item) => item.thickness === thickness);
}
